export const condimentGroupModalLanguage = {
    en: {
        NewCondimentGroup: 'New Condiment Group',
        GroupName: 'Group Name',
        Ok: 'OK',
        Cancel: 'Cancel',
    },
    th: {
        NewCondimentGroup: 'กลุ่มเครื่องปรุงใหม่',
        GroupName: 'ชื่อกลุ่ม',
        Ok: 'ตกลง',
        Cancel: 'ยกเลิก',
    },
    cn: {
        NewCondimentGroup: '新调味品组',
        GroupName: '组名',
        Ok: '确定',
        Cancel: '取消',
    },
    kr: {
        NewCondimentGroup: '새 조미료 그룹',
        GroupName: '그룹 이름',
        Ok: '확인',
        Cancel: '취소',
    },
    jp: {
        NewCondimentGroup: '新調味料グループ',
        GroupName: 'グループ名',
        Ok: 'OK',
        Cancel: 'キャンセル',
    },
}

export const condimentGroupLanguage = {
    en: {
        CondimentGroups: 'Condiment Groups',
        GroupName: 'Group Name',
        SelectionType: 'Selection Type',
        Single: 'Single',
        Multiple: 'Multiple',
        NewLine: 'New Line',
        Add: 'Add',
        ModifySave: 'Modify / Save',
        Delete: 'Delete',
        SuccessTitle: 'Success!',
        SuccessText: 'Condiment group updated successfully',
        ConfirmRemoveTitle: 'Are you sure?',
        ConfirmRemoveText: "You won't be able to revert this!",
        Confirm: 'Confirm',
        Deleted: 'Deleted!',
        DeletedText: 'Your file has been deleted.',
        Cancel: 'Cancel',
    },
    th: {
        CondimentGroups: 'กลุ่มเครื่องปรุง',
        GroupName: 'ชื่อกลุ่ม',
        SelectionType: 'ประเภทการเลือก',
        Single: 'เดี่ยว',
        Multiple: 'หลาย',
        NewLine: 'ขึ้นบรรทัดใหม่',
        Add: 'เพิ่ม',
        ModifySave: 'แก้ไข / บันทึก',
        Delete: 'ลบ',
        SuccessTitle: 'สำเร็จ!',
        SuccessText: 'อัปเดตกลุ่มเครื่องปรุงสำเร็จ',
        ConfirmRemoveTitle: 'คุณแน่ใจหรือไม่?',
        ConfirmRemoveText: 'คุณจะไม่สามารถย้อนกลับได้!',
        Confirm: 'ยืนยัน',
        Deleted: 'ลบแล้ว!',
        DeletedText: 'ไฟล์ของคุณถูกลบแล้ว',
        Cancel: 'ยกเลิก',
    },
    cn: {
        CondimentGroups: '调味品组',
        GroupName: '组名',
        SelectionType: '选择类型',
        Single: '单选',
        Multiple: '多选',
        NewLine: '新行',
        Add: '添加',
        ModifySave: '修改 / 保存',
        Delete: '删除',
        SuccessTitle: '成功！',
        SuccessText: '调味品组已成功更新',
        ConfirmRemoveTitle: '你确定吗？',
        ConfirmRemoveText: '此操作无法撤销！',
        Confirm: '确认',
        Deleted: '已删除！',
        DeletedText: '您的文件已被删除。',
        Cancel: '取消',
    },
    kr: {
        CondimentGroups: '조미료 그룹',
        GroupName: '그룹 이름',
        SelectionType: '선택 유형',
        Single: '단일',
        Multiple: '다중',
        NewLine: '새 줄',
        Add: '추가',
        ModifySave: '수정 / 저장',
        Delete: '삭제',
        SuccessTitle: '성공!',
        SuccessText: '조미료 그룹이 성공적으로 업데이트되었습니다',
        ConfirmRemoveTitle: '확실합니까?',
        ConfirmRemoveText: '이 작업은 되돌릴 수 없습니다!',
        Confirm: '확인',
        Deleted: '삭제됨!',
        DeletedText: '파일이 삭제되었습니다.',
        Cancel: '취소',
    },
    jp: {
        CondimentGroups: '調味料グループ',
        GroupName: 'グループ名',
        SelectionType: '選択タイプ',
        Single: 'シングル',
        Multiple: 'マルチ',
        NewLine: '新しい行',
        Add: '追加',
        ModifySave: '修正 / 保存',
        Delete: '削除',
        SuccessTitle: '成功！',
        SuccessText: '調味料グループが正常に更新されました',
        ConfirmRemoveTitle: 'よろしいですか？',
        ConfirmRemoveText: 'この操作は元に戻せません！',
        Confirm: '確認',
        Deleted: '削除されました！',
        DeletedText: 'ファイルが削除されました。',
        Cancel: 'キャンセル',
    },
}

export const condimentsAltLangModalLanguage = {
    en: {
        AlternativeDisplayLanguage: 'Alternative Display Language',
        Ok: 'OK',
        Cancel: 'Cancel',
    },
    th: {
        AlternativeDisplayLanguage: 'ภาษาแสดงทางเลือก',
        Ok: 'ตกลง',
        Cancel: 'ยกเลิก',
    },
    cn: {
        AlternativeDisplayLanguage: '替代显示语言',
        Ok: '确定',
        Cancel: '取消',
    },
    kr: {
        AlternativeDisplayLanguage: '대체 표시 언어',
        Ok: '확인',
        Cancel: '취소',
    },
    jp: {
        AlternativeDisplayLanguage: '代替表示言語',
        Ok: 'OK',
        Cancel: 'キャンセル',
    },
}

export const condimentsAppearanceLanguage = {
    en: {
        NoImage: 'No Image',
        UploadImage: 'Upload Image',
        RemoveImage: 'Remove Image',
        ButtonColor: 'Button Color',
        ButtonFontSize: 'Button Font Size',
        XLarge: 'X-Large',
        Large: 'Large',
        Medium: 'Medium',
        Small: 'Small',
        Red: 'Red',
        Green: 'Green',
        Blue: 'Blue',
        Yellow: 'Yellow',
        Cyan: 'Cyan',
        Magenta: 'Magenta',
        Orange: 'Orange',
        Purple: 'Purple',
        Brown: 'Brown',
        Pink: 'Pink',
        Lime: 'Lime',
        Teal: 'Teal',
    },
    th: {
        NoImage: 'ไม่มีรูปภาพ',
        UploadImage: 'อัปโหลดรูปภาพ',
        RemoveImage: 'ลบรูปภาพ',
        ButtonColor: 'สีปุ่ม',
        ButtonFontSize: 'ขนาดตัวอักษรปุ่ม',
        XLarge: 'ขนาดใหญ่มาก',
        Large: 'ขนาดใหญ่',
        Medium: 'ขนาดกลาง',
        Small: 'ขนาดเล็ก',
        Red: 'แดง',
        Green: 'เขียว',
        Blue: 'น้ำเงิน',
        Yellow: 'เหลือง',
        Cyan: 'ฟ้า',
        Magenta: 'ม่วงแดง',
        Orange: 'ส้ม',
        Purple: 'ม่วง',
        Brown: 'น้ำตาล',
        Pink: 'ชมพู',
        Lime: 'เขียวอ่อน',
        Teal: 'เขียวอมฟ้า',
    },
    cn: {
        NoImage: '无图片',
        UploadImage: '上传图片',
        RemoveImage: '移除图片',
        ButtonColor: '按钮颜色',
        ButtonFontSize: '按钮字体大小',
        XLarge: '特大',
        Large: '大',
        Medium: '中',
        Small: '小',
        Red: '红色',
        Green: '绿色',
        Blue: '蓝色',
        Yellow: '黄色',
        Cyan: '青色',
        Magenta: '品红',
        Orange: '橙色',
        Purple: '紫色',
        Brown: '棕色',
        Pink: '粉色',
        Lime: '酸橙色',
        Teal: '蓝绿色',
    },
    kr: {
        NoImage: '이미지 없음',
        UploadImage: '이미지 업로드',
        RemoveImage: '이미지 제거',
        ButtonColor: '버튼 색상',
        ButtonFontSize: '버튼 글꼴 크기',
        XLarge: '특대',
        Large: '대',
        Medium: '중',
        Small: '소',
        Red: '빨강',
        Green: '초록',
        Blue: '파랑',
        Yellow: '노랑',
        Cyan: '청록',
        Magenta: '마젠타',
        Orange: '주황',
        Purple: '보라',
        Brown: '갈색',
        Pink: '분홍',
        Lime: '라임',
        Teal: '청록색',
    },
    jp: {
        NoImage: '画像なし',
        UploadImage: '画像をアップロード',
        RemoveImage: '画像を削除',
        ButtonColor: 'ボタンの色',
        ButtonFontSize: 'ボタンのフォントサイズ',
        XLarge: '特大',
        Large: '大',
        Medium: '中',
        Small: '小',
        Red: '赤',
        Green: '緑',
        Blue: '青',
        Yellow: '黄',
        Cyan: 'シアン',
        Magenta: 'マゼンタ',
        Orange: 'オレンジ',
        Purple: '紫',
        Brown: '茶色',
        Pink: 'ピンク',
        Lime: 'ライム',
        Teal: 'ティール',
    },
}

export const condimentsBasicLanguage = {
    en: {
        CondimentName: 'Condiment Name',
        Name: 'Name',
        Price: 'Price',
        Threshold: 'Threshold',
        Preset: 'Preset',
        AlternativeDisplayLanguage: 'Alternative Display Language',
    },
    th: {
        CondimentName: 'ชื่อเครื่องปรุง',
        Name: 'ชื่อ',
        Price: 'ราคา',
        Threshold: 'เกณฑ์',
        Preset: 'ค่าตั้งต้น',
        AlternativeDisplayLanguage: 'ภาษาแสดงทางเลือก',
    },
    cn: {
        CondimentName: '调味品名称',
        Name: '名称',
        Price: '价格',
        Threshold: '阈值',
        Preset: '预设',
        AlternativeDisplayLanguage: '替代显示语言',
    },
    kr: {
        CondimentName: '조미료 이름',
        Name: '이름',
        Price: '가격',
        Threshold: '임계값',
        Preset: '프리셋',
        AlternativeDisplayLanguage: '대체 표시 언어',
    },
    jp: {
        CondimentName: '調味料名',
        Name: '名前',
        Price: '価格',
        Threshold: 'しきい値',
        Preset: 'プリセット',
        AlternativeDisplayLanguage: '代替表示言語',
    },
}

export const condimentsDetailsLanguage = {
    en: {
        Basic: 'Basic',
        Appearance: 'Appearance',
        ModifySave: 'Modify / Save',
        Delete: 'Delete',
        SuccessTitle: 'Success!',
        SuccessText: 'Condiment details updated successfully',
        ConfirmRemoveTitle: 'Are you sure?',
        ConfirmRemoveText: "You won't be able to revert this!",
        Confirm: 'Confirm',
        Deleted: 'Deleted!',
        DeletedText: 'Your file has been deleted.',
        Cancel: 'Cancel',
    },
    th: {
        Basic: 'ข้อมูลพื้นฐาน',
        Appearance: 'ลักษณะ',
        ModifySave: 'แก้ไข / บันทึก',
        Delete: 'ลบ',
        SuccessTitle: 'สำเร็จ!',
        SuccessText: 'อัปเดตรายละเอียดเครื่องปรุงสำเร็จ',
        ConfirmRemoveTitle: 'คุณแน่ใจหรือไม่?',
        ConfirmRemoveText: 'คุณจะไม่สามารถย้อนกลับได้!',
        Confirm: 'ยืนยัน',
        Deleted: 'ลบแล้ว!',
        DeletedText: 'ไฟล์ของคุณถูกลบแล้ว',
        Cancel: 'ยกเลิก',
    },
    cn: {
        Basic: '基本信息',
        Appearance: '外观',
        ModifySave: '修改 / 保存',
        Delete: '删除',
        SuccessTitle: '成功！',
        SuccessText: '调味品详情已成功更新',
        ConfirmRemoveTitle: '你确定吗？',
        ConfirmRemoveText: '此操作无法撤销！',
        Confirm: '确认',
        Deleted: '已删除！',
        DeletedText: '您的文件已被删除。',
        Cancel: '取消',
    },
    kr: {
        Basic: '기본',
        Appearance: '외관',
        ModifySave: '수정 / 저장',
        Delete: '삭제',
        SuccessTitle: '성공!',
        SuccessText: '조미료 세부 정보가 성공적으로 업데이트되었습니다',
        ConfirmRemoveTitle: '확실합니까?',
        ConfirmRemoveText: '이 작업은 되돌릴 수 없습니다!',
        Confirm: '확인',
        Deleted: '삭제됨!',
        DeletedText: '파일이 삭제되었습니다.',
        Cancel: '취소',
    },
    jp: {
        Basic: '基本',
        Appearance: '外観',
        ModifySave: '修正 / 保存',
        Delete: '削除',
        SuccessTitle: '成功！',
        SuccessText: '調味料の詳細が正常に更新されました',
        ConfirmRemoveTitle: 'よろしいですか？',
        ConfirmRemoveText: 'この操作は元に戻せません！',
        Confirm: '確認',
        Deleted: '削除されました！',
        DeletedText: 'ファイルが削除されました。',
        Cancel: 'キャンセル',
    },
}

export const condimentsListLanguage = {
    en: {
        Departments: 'Departments',
        AddCondiment: 'Add Condiment',
    },
    th: {
        Departments: 'แผนก',
        AddCondiment: 'เพิ่มเครื่องปรุง',
    },
    cn: {
        Departments: '部门',
        AddCondiment: '添加调味品',
    },
    kr: {
        Departments: '부서',
        AddCondiment: '조미료 추가',
    },
    jp: {
        Departments: '部門',
        AddCondiment: '調味料を追加',
    },
}

export const condimentsModalLanguage = {
    en: {
        NewCondiment: 'New Condiment',
        CondimentName: 'Condiment Name',
        CondimentPrice: 'Condiment Price',
        Ok: 'OK',
        Cancel: 'Cancel',
    },
    th: {
        NewCondiment: 'เครื่องปรุงใหม่',
        CondimentName: 'ชื่อเครื่องปรุง',
        CondimentPrice: 'ราคาเครื่องปรุง',
        Ok: 'ตกลง',
        Cancel: 'ยกเลิก',
    },
    cn: {
        NewCondiment: '新调味品',
        CondimentName: '调味品名称',
        CondimentPrice: '调味品价格',
        Ok: '确定',
        Cancel: '取消',
    },
    kr: {
        NewCondiment: '새 조미료',
        CondimentName: '조미료 이름',
        CondimentPrice: '조미료 가격',
        Ok: '확인',
        Cancel: '취소',
    },
    jp: {
        NewCondiment: '新しい調味料',
        CondimentName: '調味料名',
        CondimentPrice: '調味料の価格',
        Ok: 'OK',
        Cancel: 'キャンセル',
    },
}